import { ReactNode } from 'react'
import { XStack, XStackProps, YStack, YStackProps } from 'tamagui'
import { createStateContext } from '../factory/createStateContext'
import { ColorScheme } from '../themes/utils'
import { Button, ButtonProps } from './Button'
import { IconButton, IconButtonProps } from './IconButton'
import { H2, HeadingProps, Text, TextProps } from './text'

const [Context, useContext] = createStateContext<{ colorScheme: ColorScheme }>({
  colorScheme: 'primary',
})

export type TileTitleProps = HeadingProps

export const TileTitle = ({ children, ...rest }: TileTitleProps) => {
  return (
    <H2 size="$md" color={`$neutral.800`} cursor={'pointer'} {...rest}>
      {children}
    </H2>
  )
}

export type TileTitleContainerProps = XStackProps

export const TileTitleContainer = ({
  children,
  ...rest
}: TileTitleContainerProps) => {
  return (
    <XStack justifyContent="space-between" alignItems="center" {...rest}>
      {children}
    </XStack>
  )
}

export type TileTitleButtonProps = IconButtonProps

export const TileTitleButton = ({
  children,
  ...rest
}: TileTitleButtonProps) => {
  return <IconButton size="$xs" {...rest} />
}

export type TileDescriptionProps = TextProps

export const TileDescription = ({
  children,
  ...rest
}: TileDescriptionProps) => {
  return (
    <Text size="$sm" mt="$1" color={`$neutral.600`} {...rest}>
      {children}
    </Text>
  )
}

export type TileButtonProps = ButtonProps

export const TileButton = ({ children, ...props }: TileButtonProps) => {
  const [{ colorScheme }] = useContext()
  return (
    <Button
      marginTop="$3"
      size="$xs"
      backgroundColor={`$${colorScheme}.500`}
      {...props}
    >
      {children}
    </Button>
  )
}

export type TileProps = YStackProps & {
  children: ReactNode
  colorScheme?: ColorScheme
}

export const Tile = ({
  children,
  colorScheme = 'primary',
  ...rest
}: TileProps) => {
  return (
    <Context initialValue={{ colorScheme }}>
      <YStack
        p="$4"
        backgroundColor={`$neutral.100`}
        borderRadius={'$3'}
        borderWidth={1}
        borderColor="$neutral.200"
        {...rest}
      >
        {children}
      </YStack>
    </Context>
  )
}
